<template lang="pug">

    div
        .ui.secondary.menu

            router-link.item(:to='{ name: "users" }' exact) Übersicht Benutzer
            router-link.item(:to='{ name: "users/update" }' v-if="isUpdateVisible")  Benutzer bearbeiten
            router-link.item(:to='{ name: "users/create" }')  Benutzer anlegen

        .ui.divider

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {
            isUpdateVisible() {
                return this.$route.name === 'users/update'
            },
        }

    }

</script>
